import { fetchUser } from "@/api/endpoints/user";
import { useQuery } from "@tanstack/react-query";

export const useUser = (uuid?: string) => {
  return useQuery({
    queryKey: ["user", uuid || "me"],
    queryFn: ({ queryKey }) => {
      const [, userId] = queryKey;
      return fetchUser(userId as string);
    },
    refetchOnWindowFocus: false,
  });
};
